// Deep copies and merges of the customizer's nested objects (a design's keycaps and their
// entries): deepMerge and deepClone out of CustomizerScreen (backfill PR 24, for the legend
// assignment), deepCopy out of CustomizerScreen and ProcessOrderScreen (PR 25).
export function deepMerge(target, source) {
  for (const key of Object.keys(source)) {
    if (source[key] instanceof Object && key in target) {
      Object.assign(source[key], deepMerge(target[key], source[key]));
    }
  }

  Object.assign(target, source); // joining `target` and modified `source`
  return target;
} // recursively merges properties from the source object into the target object (used to merge keycap values. This is needed, because if a design is imported from the data base, it only comes with the most necessary values. Then I add other values to the objects of the imported design, like default text and svg value, aswell as dimensions, group and colorGroup values. Also the isSpace objects have to be added to the imported design, but that is not done by the deepMerge function)

export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') return obj; // Return non-objects and null values as is

  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)); // Recursively clone each element if obj is an array
  }

  const clonedObj = {}; // Initialize an empty object for deep cloning properties
  for (const key in obj) {
    clonedObj[key] = deepClone(obj[key]); // Recursively clone each property of the object
  }
  return clonedObj; // Return the fully cloned object
} // Creates a deep clone of an object or array, preserving nested structures

export const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}; // a copy through JSON: both screens copy defaultKeycapValues for every keycap this way (its nested texts and icons would otherwise be shared between the keycaps), and CustomizerScreen snapshots the design for the undo and redo stacks; unlike deepClone it drops a key whose value is undefined, which the design holds only in the tour's fallback selection before the layout has loaded (KNOWN_BUGS.md)
